import DatePickerModule from 'react-datepicker';
import { babelModuleDefault } from '../utils/babelModuleDefault';

export default babelModuleDefault(DatePickerModule);
